export const BASE_URL = {
    production: "https://api.cyphme.com/api/v1/cyph-client",
    staging: "https://staging.cyphme.com/api/v1/cyph-client",
    development: "http://localhost:9090/api/v1/cyph-client"
};
export const CYPH_APP_BASE_URL = "cyphme://www.cyphme.com/verifydocument?sessionId=";
export const API_DELAY = 1000;
export const MAX_RETRIES = 5;